<template>
  <div>
    <sub-menu
      :title="title"
      :routes="routes"
    ></sub-menu>

    <router-view></router-view>
  </div>
</template>

<script>
import SubMenu from '@/components/SubMenu.vue'
import { mapGetters } from 'vuex'


export default {
  data() {
    return {
      title: 'pamm',
      routes: [
        { path: '/pamm', title: 'statistics' },
        { path: '/pamm/new-master', title: 'master_account' },
      ]
    }
  },
  components: {
    SubMenu,
  },

  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
}
</script>
